module.exports = __webpack_public_path__ + "img/city_park.05dc7ade.jpg";